const generalActionTypes = {
  SET_SIDEBAR: 'SET_SIDEBAR',
  RELOAD_MANAGER_DASHBOARD: 'RELOAD_MANAGER_DASHBOARD',
};

export default generalActionTypes;
